export default defineI18nConfig(() => ({
    fallbackLocale: 'de',

    customRoutes: 'config',
    pages: {
        'overview/[registration]': {
            de: '/uebersicht/[registration]',
            en: '/overview/[registration]'
        },
        'registration/[id]': {
            de: '/anmeldung/[id]',
            en: '/registration/[id]'
        },
        'registration/[id]/regStart': {
            de: '/anmeldung/[id]/start',
            en: '/registration/[id]/start'
        },
        'registration/[id]/regSummary': {
            de: '/anmeldung/[id]/zusammenfassung',
            en: '/registration/[id]/summary'
        },
        'registration/[id]/registrationDetails': {
            de: '/anmeldung/[id]/anmeldungsDetails',
            en: '/registration/[id]/registrationDetails'
        },
        'registration/[id]/payment': {
            de: '/anmeldung/[id]/zahlung',
            en: '/registration/[id]/payment'
        },
        'registration/[id]/participantsDetails': {
            de: '/anmeldung/[id]/teilnehmerDetails',
            en: '/registration/[id]/participantsDetails'
        },
        'registration/[id]/participants': {
            de: '/anmeldung/[id]/teilnehmer',
            en: '/registration/[id]/participants'
        }
    },
    datetimeFormats: {
        'de': {
            dateShort: {
                year: 'numeric', month: 'short', day: 'numeric'
            },
            dateLong: {
                year: 'numeric', month: 'long', day: 'numeric'
            },
            dateLongWeekday: {
                year: 'numeric', month: 'long', day: 'numeric', weekday: 'short'
            },
            dateLongWithoutYear: {
                month: 'long', day: 'numeric'
            },
            dateNumeric: {
                year: 'numeric', month: '2-digit', day: '2-digit'
            },
            dateNumericDay: {
                day: 'numeric'
            },
            dateShortMonth: {
                month: 'short', day: '2-digit'
            },
            dateNumeric2Digit: {
                year: '2-digit', month: '2-digit', day: '2-digit'
            },
            dateNumeric2DigitWeekday: {
                year: '2-digit', month: '2-digit', day: '2-digit', weekday: 'short'
            },
            dateShortWithoutDay: {
                year: 'numeric', month: 'short'
            },
            dateTime: {
                year: 'numeric', month: 'short', day: 'numeric',
                weekday: 'short', hour: 'numeric', minute: 'numeric'
            },
            dateTimeLong: {
                year: 'numeric', month: 'long', day: 'numeric',
                hour: 'numeric', minute: 'numeric'
            },
            dateTimeLongWeekday: {
                year: 'numeric', month: 'long', day: 'numeric',
                weekday: 'short', hour: 'numeric', minute: 'numeric'
            },
            dateTimeNumeric: {
                year: 'numeric', month: '2-digit', day: '2-digit',
                hour: 'numeric', minute: 'numeric'
            },
            dateTimeShort: {
                year: 'numeric', month: 'short', day: 'numeric',
                hour: 'numeric', minute: 'numeric'
            },
            year: {
                year: 'numeric'
            },
            monthShort: {
                month: 'short'
            },
            time: {
                hour: 'numeric', minute: 'numeric'
            }
        },
        'en': {
            dateShort: {
                year: 'numeric', month: 'short', day: 'numeric'
            },
            dateTime: {
                year: 'numeric', month: 'short', day: 'numeric',
                weekday: 'short', hour: 'numeric', minute: 'numeric'
            },
        }
    }
}))
